// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import { PlasmicProfileSeo, DefaultProfileSeoProps } from './plasmic/paziresh_24_profile/PlasmicProfileSeo';
import { HTMLElementRefOf } from '@plasmicapp/react-web';

export interface ProfileSeoProps extends Omit<DefaultProfileSeoProps, 'bredcrumbs'> {
  /** Preferred spelling — mapped to Plasmic's misspelled `bredcrumbs` prop. */
  breadcrumbs?: any;
  /** Plasmic-generated prop name (typo). Prefer `breadcrumbs`. */
  bredcrumbs?: any;
}

function ProfileSeo_(props: ProfileSeoProps, ref: HTMLElementRefOf<'div'>) {
  const { breadcrumbs, bredcrumbs, ...rest } = props;

  return (
    <PlasmicProfileSeo
      root={{ ref }}
      {...rest}
      // Generated Plasmic API uses `bredcrumbs`; accept correct spelling from callers.
      bredcrumbs={bredcrumbs ?? breadcrumbs}
    />
  );
}

const ProfileSeo = React.forwardRef(ProfileSeo_);
export default ProfileSeo;
